var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tile-grid',_vm._l((_vm.getServicesByPlaceAndGroup(_vm.getPlace, _vm.getServiceGroup)),function(service){return _c('service-tile',{key:service.id,attrs:{"selected":_vm.$_.includes(_vm.selectedServices, service.id),"service":service},on:{"serviceSelected":_vm.serviceSelected,"serviceDeselected":_vm.serviceDeselected}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }